module.exports = __webpack_public_path__ + "a2fc2a965f48caeee3adf0ebb08ffb8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-04-harrison-first-day-in-india/boat-with-dad.jpg
// module id = 568
// module chunks = 0